import * as Yup from "yup";
import {userSchema} from "./userSchema";
import {departmentSchema} from "./departmentSchema";

export const changeRequestSchema = Yup.object().shape({
  requestDate: Yup.date(), // 발의 일자
  type: Yup.number(), // 변경구분  0 - 정상변경, 1 - 임시변경, 2 - 비상변경
  estimateDate: Yup.date(), // 복구예정일
  status: Yup.number(), // 상태  0 - 진행, 1 - 완료, 2 - 반려, 3 - 지연
  statusContent: Yup.string(), // 반려/지연 사유
  content: Yup.string(), // 변경 내용
  base64Attachment: Yup.string(), // 변경검토근거자료
  completeDate: Yup.date(), // 완료일
  requestFile: Yup.string(), // 변경요구서

  // note 공정안전
  hasProcessSafety: Yup.boolean(), // 공정안전자료 여부
  hasProcessEval: Yup.boolean(), // 공정위험성평가 여부
  hasSafetyProcedure: Yup.boolean(), // 안전운전절차 여부
  hasEmergency: Yup.boolean(), // 비상조치계획 여부
  hasEducation: Yup.boolean(), // 근로자교육 여부

  processSafetyFile: Yup.string(), // 공정안전자료 파일명
  processFile: Yup.string(), // 공정위험성평가 파일명
  procedureFile: Yup.string(), // 안전운전절차 파일명
  emergencyFile: Yup.string(), // 비상조치계획 파일명
  educationFile: Yup.string(), // 근로자교육평가 파일명
  preCheckFile: Yup.string(), // 가동전점검 파일명

  // note note used
  // uid: Yup.number(),
  // guid: Yup.string(),
  // companyUID: Yup.number(),
  // requesterUID: Yup.number(),
  // serialNo: Yup.number(), // 일련번호
  // level: Yup.string(), // 변경등급
  // extension: Yup.string(), // 변경검토근거자료 확장자
  // attachmentFileName: Yup.string(), // 변경검토근거자료 파일명
  // entryDate: Yup.date(),
  // isDeleted: Yup.boolean(),

  // // --------------- Non DB Properties
  // base64Request: Yup.string(), // 변경요구서
  // base64ProcessSafety: Yup.string(), // 공정안전자료
  // base64Process: Yup.string(), // 공정위험성평가
  // base64Procedure: Yup.string(), // 안전운전절차
  // base64Emergency: Yup.string(), // 비상조치계획
  // base64Education: Yup.string(), // 근로자교육평가
  // base64PreCheck: Yup.string(), // 가동전점검

  // // NOT DB
  // requester: Yup.array().of(userSchema), // 발의자
  // department: Yup.array().of(departmentSchema), // 발의자의 부서
  // serialString: Yup.string(), // 일련번호 문자열
});
